export default __webpack_public_path__ + "static/media/M07.828bbf7c.jpg";